import { AnyObject } from '@xbcb/shared-types';
import {
  ValidationErrorType,
  type AdditionalFormError,
  type NamePath,
} from '@xbcb/ui-types';

const MIN_PACKAGING_LEVELS = 2;
// Pesticide PGA flags (EP5 = may be required, EP6 = required).
const PESTICIDE_FLAGS = new Set(['EP5', 'EP6']);

// EPA pesticide lines must report at least two ordered packaging levels, so the
// operator sees it in the form instead of at submission.
export const validateEpaPesticides = ({
  pga,
  pgaFlag,
  tariffNamePath,
  errorPrefix = '',
}: {
  pga: AnyObject;
  pgaFlag: string;
  tariffNamePath: NamePath;
  errorPrefix?: string;
}): { additionalErrors: AdditionalFormError[] } => {
  const additionalErrors: AdditionalFormError[] = [];

  if (pga?.agencyCode !== 'EPA' || !PESTICIDE_FLAGS.has(pgaFlag)) {
    return { additionalErrors };
  }

  const packaging = pga?.packaging ?? [];
  if (packaging.length < MIN_PACKAGING_LEVELS) {
    additionalErrors.push({
      title: 'Packaging Levels Required',
      type: ValidationErrorType.GENERAL,
      path: tariffNamePath,
      messages: [
        `${errorPrefix}EPA pesticides require at least two ordered packaging levels`,
      ],
    });
  }

  packaging.forEach((level: AnyObject, index: number) => {
    const levelNumber = index + 1;
    if (level?.value == null || level.value === 0) {
      additionalErrors.push({
        title: 'Packaging Quantity Required',
        type: ValidationErrorType.GENERAL,
        path: tariffNamePath,
        messages: [
          `${errorPrefix}Packaging level ${levelNumber} needs a quantity`,
        ],
      });
    }
    if (!level?.unit) {
      additionalErrors.push({
        title: 'Packaging Unit Required',
        type: ValidationErrorType.GENERAL,
        path: tariffNamePath,
        messages: [
          `${errorPrefix}Packaging level ${levelNumber} needs a unit of measure`,
        ],
      });
    }
  });

  return { additionalErrors };
};
